import { render, staticRenderFns } from "./RichTextInput.vue?vue&type=template&id=e9c5a4fe&scoped=true&"
import script from "./RichTextInput.vue?vue&type=script&lang=js&"
export * from "./RichTextInput.vue?vue&type=script&lang=js&"
import style0 from "./RichTextInput.vue?vue&type=style&index=0&id=e9c5a4fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c5a4fe",
  null
  
)

export default component.exports